import React from "react";
import Datatable from "../common/datatable/datatable";
import { fetchData } from "./../../utils/fetch";
import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { compose } from "recompose";
import { connect } from "react-redux";

const Posts = (props) => {
  const [state, setState] = useState({
    posts: [],
  });
  

  useEffect(
    () => {
      const fetchData = async () => {
          const posts = await fetchPosts();
          setState((prev) => ({...prev, posts: posts}))
        //posts.length
          /*setState((prev) => ({
            ...prev,
            categories: categories,
            products: products.map((el) => ({
              id: el.id,
              name: el.name,
              category: categories.find(_el => _el.id == el.category).name,
              pictures: JSON.parse(el.pictures) ? JSON.parse(el.pictures) : [{}],
              //variations: JSON.parse(el.variations),
            })),
          }));*/
      }
      fetchData();
  
    },
    
    [props.token]
  );


  const fetchPosts = async () => {
    try {
      const obj = {
        token: props.token,
        email: props.email,
      };
      let posts = await fetchData(obj, "post/get.php");
      if (posts.status === "fail") throw posts.message;
      return posts;
    } catch (error) {
      console.log(error);
      return []
    }
  };

  return (
    <>
      <Link to={`/post/new/`}>Adauga o noua postare</Link>
      <Datatable
        //edit={edit}
        //remove={remove}
        path="post"
        myData={[...state.posts]}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  token: state.account.token,
  email: state.account.email,
});

export default compose(connect(mapStateToProps))(Posts);
